import React, {useState, useEffect} from "react"
import data from "../../../../../data"
import Util from "../../../../../util"

function CustomizeParticipants({activity, regionCode, participantCount, onChange}) {
  // state
  const [items, setItems] = useState([])

  // displayed items need to change when activity or region change
  useEffect(() => {
    if(activity && regionCode) {
      const priceConfigurations = data.Activity.getPriceConfigurations(activity, regionCode)
      .sort((a, b) => {
        return Number(a.participantCount) > Number(b.participantCount) ? 1 : -1
      })
      .map(pc => {
        return <option value={pc.participantCount} key={pc.participantCount}>{pc.participantCount} Teilnehmer, {Util.Format.currency(pc.price, true)}</option>
      })
      setItems(priceConfigurations)
    }
  }, [activity, regionCode])

  // render
  if(!regionCode) {
    return null
  }
  return (
    <div className="customize-participants">
      <h2>Anzahl Teilnehmer</h2>
      <select value={participantCount} onChange={e => {
        onChange(Number(e.target.value))
      }}>
        {items}
      </select>
    </div>
  )
}

export default CustomizeParticipants
